export default [
    {
        path: '/tranfer/internal/add',
        name: 'add_internal_transfer',
        component: () => import('@/views/for_student/academic_requests/internal_transfer/internal_transfer'),
        meta: { pageTitle: 'request internal transfer', breadcrumb: [{to: '/tranfer/internal', text: 'Internal Transfer'},{ text: 'Add', active: true }] },
    },
    {
        path: '/tranfer/internal',
        name: 'internal_transfer',
        component: () => import('@/views/for_student/academic_requests/internal_transfer/list'),
        meta: { pageTitle: 'request internal transfer', breadcrumb: [{ text: 'Internal Transfer', active: true }] },
    },

    {
        path: '/tranfer/out',
        name: 'transfer_out',
        component: () => import('@/views/for_student/academic_requests/transfer_out'),
        meta: { pageTitle: 'request transfer out', breadcrumb: [{ text: 'Transfer Out', active: true }] },
    },
  ]
  